<template>
  <div class="crm-dashboard">
    <el-card class="data-simple" shadow="never">
      <div slot="header">
        <span>账户统计</span>
      </div>
      <el-row :gutter="20">
        <el-col :xs="24" :md="12" :lg="8">
          <div>
            <el-card class="data-card" shadow="always">
              <div class="data-block">
                <div class="value">{{generalInfoData.openTenantNum}}</div>
                <div class="label">已开通账户</div>
              </div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="24" :md="12" :lg="8">
          <div>
            <el-card class="data-card" shadow="always">
              <div class="data-block">
                <div class="value">{{generalInfoData.weekNewAddTenantNum}}
                    <i class="el-icon-bottom" v-if="generalInfoData.weekNewAddCompareLastFlag === 2"/>
                    <i class="el-icon-top" v-else-if="generalInfoData.weekNewAddCompareLastFlag === 1"/>
                </div>
                <div class="label">本周新增</div>
              </div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="24" :md="12" :lg="8">
          <div>
            <el-card class="data-card" shadow="always">
              <div class="data-block">
                <div class="value">
                    {{generalInfoData.monthNewAddTenantNum}}
                    <i class="el-icon-bottom" v-if="generalInfoData.monthNewAddCompareLastFlag === 2"/>
                    <i class="el-icon-top" v-else-if="generalInfoData.monthNewAddCompareLastFlag === 1"/>
                </div>
                <div class="label">本月新增</div>
              </div>
            </el-card>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :xs="24" :md="12" :lg="8">
          <div>
            <el-card class="data-card" shadow="always">
              <div class="data-block">
                <div class="value">{{amountFormat(generalInfoData.totalReceiveAmount)}}</div>
                <div class="label">累计收费(元)</div>
              </div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="24" :md="12" :lg="8">
          <div>
            <el-card class="data-card" shadow="always">
              <div class="data-block">
                <div class="value">{{amountFormat(generalInfoData.weekNewAddAmount)}}</div>
                <div class="label">本周新增(元)</div>
              </div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="24" :md="12" :lg="8">
          <div>
            <el-card class="data-card" shadow="always">
              <div class="data-block">
                <div class="value">{{amountFormat(generalInfoData.monthNewAddAmount)}}</div>
                <div class="label">本月新增(元)</div>
              </div>
            </el-card>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <el-card class="data-simple" shadow="never">
      <div slot="header">
        <span>到期统计</span>
      </div>
      <el-row :gutter="10">
        <el-col :xs="24" :md="12" :lg="6">
          <div>
            <el-card class="data-card" shadow="always">
              <div class="data-block">
                <div class="value">{{generalInfoData.threeDayInvalidCount}}</div>
                <div class="label">3天内到期</div>
              </div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <div>
            <el-card class="data-card" shadow="always">
              <div class="data-block">
                <div class="value">{{generalInfoData.sevenDayInvalidCount}}</div>
                <div class="label">7天内到期</div>
              </div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <div>
            <el-card class="data-card" shadow="always">
              <div class="data-block">
                <div class="value">{{generalInfoData.fifteenDayInvalidCount}}</div>
                <div class="label">15天内到期</div>
              </div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <div>
            <el-card class="data-card" shadow="always">
              <div class="data-block">
                <div class="value">{{generalInfoData.hasInvalidedCount}}</div>
                <div class="label">已过期</div>
              </div>
            </el-card>
          </div>
        </el-col>
      </el-row>
    </el-card>


    <el-card class="data-funnel" shadow="never">
      <div slot="header">
        <span>销售趋势</span>
      </div>
      <el-row :gutter="20">
        <el-col :xs="24" :md="12" :lg="24">
          <el-card shadow="never" style="height: 522px">
            <el-row>
              <el-col :span="12" align="left">
                <div class="yearPicker">
                  <el-date-picker v-model="dashBoardForm.year" type="year" @change="dateChange"
                                  value-format="yyyy" style="margin-top: 10px; width: 120px" placeholder="请选择年份"/>
                </div>
              </el-col>
            </el-row>
            <BusinessTrendChart :chartData="trendData"/>
          </el-card>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import { generalInfo, saleTrend } from '@/api/saas/package'
import { amountFormat } from '@/utils/index'
import BusinessTrendChart from  "@/views/crm/dashboard/businessTrendChart";

export default {
  name: "index",
  props: {
  },
  data() {
    return {
      amountFormat,
      generalInfoData: {}, // 数据概况
      trendData: {
        dataType: 'trend',
        data: []
      },
      dashBoardForm: {
        year: new Date().getFullYear().toString(),
      },
    };
  },
  components: {
    BusinessTrendChart,
  },
  watch: {
  },
  mounted() {
      this.generalInfo()
      this.saleTrend()
  },
  methods: {
      // 账户统计，到期统计
    generalInfo() {
        generalInfo().then(response => {
            this.generalInfoData = response.data;
        });
    },
    // 销售统计
    saleTrend() {
        saleTrend(this.dashBoardForm).then(response => {
            this.trendInfo = response.data;
            let newTrendData = []
            this.trendInfo.forEach(item => {
                newTrendData.push(item.amount)
            })
            this.trendData.data = newTrendData
        });
    },
    dateChange (year) {
      this.dashBoardForm.year = year
      this.saleTrend()
    }
  }
};
</script>

<style lang='scss'>
.crm-dashboard {
  .data-simple {
    margin: 0 10px 10px 10px;
    border: 0;
    .data-card {
      cursor: pointer;
      margin: 2px 0;
      .data-block {
        height: 100px;
        text-align: center;
        .label {
          font-weight: 500;
          padding-top: 30px;
        }
        .value {
          font-weight: 400;
          padding-top: 20px;
        }
      }
    }
    .data-card:hover {
      color: #4480F3;
      border-color: #c7d9fb;
      background-color: #ecf2fe;
    }
  }
  .data-funnel {
    border: 0;
    margin: 10px;
  }

  .moreBtn {
    float: right;
    margin-top: -25px;
  }

  .dynamicList {
    border-bottom: 1px solid #e8e6e6;
    margin-top: 12px;
    padding-bottom: 10px;
    font-size: 13px;
  }

  .dynamicList2 {
    border-bottom: 1px solid #e8e6e6;
    margin-top: 12px;
    padding-bottom: 10px;
    font-size: 14px;
  }

  .cardLeftTopTitle {
    color: #9ea1a7;
    font-size: 14px
  }

  .dynamicCard {
    min-height: 100px;
    height: 220px;
  }

  .noDataTip {
    margin-left: 45%;
    margin-top: 15px;
    color: #b7b5b5;
    font-size: 14px;
  }

  .dynamicContent {
    margin-top: 8px;
    width:96%;
    overflow:hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow:ellipsis;
  }

  .toDetailBtn {
    float: right;
    margin-top: -15px;
    padding: 0px;
  }

  .dynamicCreatTime {
    color: #969494;
  }

  .yearPicker {
    margin-top: -15px;
  }
}
</style>
